// import { useNavigate } from "react-router-dom";
// import Layout from "./Layout";
// import galleryImg1 from "../assets/images/gallery-img-1.jpg";
// import galleryImg2 from "../assets/images/gallery-img-2.jpg";
// import galleryImg3 from "../assets/images/gallery-img-3.jpg";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Link } from "react-router-dom";
// import config from '../config';
// import axios from "axios";
// import React, { useEffect, useState, useRef } from "react";
// import { useParams } from "react-router-dom";
// import eventLargeImage from "../assets/images/largeEvent.jpg"
// import BookingBG from "../assets/images/bookingBackground.jpg"

// import Lightbox from "react-image-lightbox"; // Import Lightbox
// import "react-image-lightbox/style.css";

// const SinglePackeges = () => {

//     const [isOpen, setIsOpen] = useState(false); // Lightbox state
//     const [currentImage, setCurrentImage] = useState(""); // Current image state
//     const [event, setEvent] = useState();
//     const { id } = useParams();
//     const eventsRef = useRef(null);
//     const [activeTab, setActiveTab] = useState("venue");
//     const [events, setEvents] = useState([]);
//     const venueRef = useRef(null);
//     const itineraryRef = useRef(null);
//     const galleryRef = useRef(null);
//     const [featuredEvent, setFeaturedEvent] = useState();
//     const images = [galleryImg1, galleryImg2, galleryImg3]; // Array of images

//     const handleImageClick = (image) => {
//         setCurrentImage(image); // Set the clicked image
//         setIsOpen(true); // Open the lightbox
//     };

//     const fetchEvent = async () => {
//         try {
//             const response = await axios.get(`${config.BASE_URL}/api/admin/single-event/${id}`, { withCredentials: true });

//             if (response.data) {
//                 setEvent(response.data);
//             }

//         } catch (err) {
//             console.log('Failed to fetch events');
//         }
//     };

//     const toggleTab = (e, tabName, ref) => {
//         e.preventDefault();

//         setActiveTab(tabName);
//         if (ref.current) {
//             ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//     }

//     useEffect(() => {
//         if (id) {
//             fetchEvent();
//         }
//     }, []);

//     if (!event) return null;

//     return (
//         <Layout extraClass={"single-event"}>
//             <>
//                 <div className="single-main-banner hero-section full-screen d-flex justify-content-center align-items-end bottom-150 bottom-overlay-dark position-relative" ref={venueRef}>
//                     <div className="hero-banner">
//                         <img width="" height="" src={config.BASE_URL + event.featuredImage} alt="" />
//                     </div>
//                     <div className="hero-summary center color-light position-absolute">
//                         <div className="title-block"><h2 className="mb-0">{event?.title}</h2></div>
//                     </div>
//                 </div>
//                 {/* <div className="hero-section grid-item events-section container-hero-section d-flex justify-content-center top-bottom-overlay position-relative">
//                     <div className="hero-banner">
//                         <img width="" height="" src={config.BASE_URL + event.featuredImage} alt="" />
//                     </div>
//                     <div className="hero-summary container-summary position-absolute center color-light">
//                         <div className="title-block">{event?.title}</div>
//                         <div className="divider position-relative">at</div>
//                         <div className="summary-wrapper">
//                             <div className="logo-block"><img width="" height="" src={venueIcon} alt="" /></div>
//                             <div className="title-block location">{event?.venueTitle}</div>
//                             <div className="cursive-title-block organizer">{event?.venueLocation}</div>
//                         </div>
//                     </div>
//                 </div> */}

//                 <div className="template-single image-overlap-sidetext-section py-180 m-pt-120 m-pb-120">
//                     <div className="container">
//                         <div className="summary-block pb-40 d-pb-70 center">
//                             <p>Staying in a private castle in Scotland offers a unique and luxurious way to experience the country's rich history and dramatic landscapes. These exclusive accommodations, often nestled in remote Highlands or perched beside serene lochs, blend historic charm with modern comforts. Guests can enjoy grand halls, antique furnishings, roaring fireplaces, and even private chefs or butlers, all while surrounded by centuries-old stone walls. </p>
//                         </div>
//                         <div className="container-500 m-auto">
//                             {/* <div className="text-block center m-auto pb-50">
//                                 <h5>{event?.centerContent?.topText}</h5>
//                             </div> */}
//                             <div className="image-block position-relative">
//                                 <img width="" height="" src={config.BASE_URL + event?.centerContentImage} alt="" />
//                                 <div className="text text-left cursive-title-block position-absolute">{event?.centerContent?.leftText}</div>
//                                 <div className="text text-right cursive-title-block position-absolute">{event?.centerContent?.rightText}</div>
//                             </div>
//                             <div className="bottom-text center d-flex justify-content-center m-auto w-100 pt-60">
//                                 <div className="text-item">
//                                     <div className="title-block">Best For</div>
//                                     <div className="text-block">{event?.bestFor}</div>
//                                 </div>
//                                 <div className="text-item">
//                                     <div className="title-block">Best Season</div>
//                                     <div className="text-block">{event?.bestSeason}</div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>




//                 <div className="title-with-line">
//                     <div className="container">
//                         <div className="title-with-line-wrapper"><h3 className="cursive-title-block">details</h3></div>
//                     </div>
//                 </div>

//                 <div className="tab-section-scroll">
//                     <ul className="list-style-none d-flex justify-content-center align-items-end">
//                         <li><a href="#event-spaces" onClick={(e) => toggleTab(e, "venue", venueRef)} className={`${activeTab === "venue" ? 'active' : ''}`}>TOP VENUES</a></li>
//                         <li><a href="#accomodation" onClick={(e) => toggleTab(e, "itinerary", itineraryRef)} className={`${activeTab === "itinerary" ? 'active' : ''}`}>HOW TO PLAN</a></li>
//                         <li><a href="#near-by" onClick={(e) => toggleTab(e, "gallery", galleryRef)} className={`${activeTab === "gallery" ? 'active' : ''}`}>BOOK WITH US</a></li>
//                     </ul>
//                 </div>

//                 <div id="venue" className="venue-banner hero-section full-screen d-flex justify-content-center align-items-end bottom-150 bottom-overlay-dark position-relative" ref={venueRef}>
//                     <div className="hero-banner">
//                         <img width="" height="" src={config.BASE_URL + event?.venueBannerImage} alt="" />
//                     </div>
//                     <div className="hero-summary center color-light position-absolute">
//                         <div className="title-block"><h2 className="mb-0">{event?.venueBannerTitle}</h2></div>
//                         <div className="text-block">{event?.venueBannerDesc}</div>
//                     </div>
//                 </div>

//                 <div className="top-venue-section">
//                     <div className="container m-px-0" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
//                         <div className="event-items py-100">
//                             <div className="grid-row">
//                                 <Swiper
//                                     spaceBetween={20}
//                                     loop={true}
//                                     centeredSlides={true}
//                                     slidesPerView={1.4}
//                                     initialSlide={2}
//                                     breakpoints={{
//                                         993: {
//                                             loop: false,
//                                             centeredSlides: false,
//                                             slidesPerView: 3,
//                                             spaceBetween: 30,
//                                         },
//                                     }}
//                                 >
//                                     <SwiperSlide>
//                                         <div className="grid-item">
//                                             <Link to=''>
//                                                 <div className="image-block"><img className="w-100" width="" height="" src={galleryImg1} alt="" /></div>
//                                                 <div className="title-block">Dundas Castle</div>
//                                                 <div className="cursive-title-block location ">west lothia</div>
//                                                 <div className="title-block organizer">Dalmeny</div>

//                                             </Link>
//                                         </div>
//                                     </SwiperSlide>
//                                     <SwiperSlide>
//                                         <div className="grid-item">
//                                             <Link to=''>
//                                                 <div className="image-block"><img className="w-100" width="" height="" src={galleryImg1} alt="" /></div>
//                                                 <div className="title-block">Dundas Castle</div>
//                                                 <div className="cursive-title-block location ">west lothia</div>
//                                                 <div className="title-block organizer">Dalmeny</div>

//                                             </Link>
//                                         </div>
//                                     </SwiperSlide>
//                                     <SwiperSlide>
//                                         <div className="grid-item">
//                                             <Link to=''>
//                                                 <div className="image-block"><img className="w-100" width="" height="" src={galleryImg1} alt="" /></div>
//                                                 <div className="title-block">Dundas Castle</div>
//                                                 <div className="cursive-title-block location ">west lothia</div>
//                                                 <div className="title-block organizer">Dalmeny</div>

//                                             </Link>
//                                         </div>
//                                     </SwiperSlide>

//                                 </Swiper>
//                             </div>
//                             <div className="view-all-button view-all-button d-flex d-pt-60">
//                                 <Link to="">VIEW ALL VENUES</Link>
//                             </div>
//                         </div>
//                     </div>
//                 </div>


//                 <div className="image-column-section bg-black color-light center py-100">
//                     <div className="container m-px-0">
//                         <div className="section-intro text-center pb-30 d-pb-100">
//                             <h2>HOW TO PLAN</h2>
//                             <div className="text-block">Planning a private castle stay in Scotland involves a few key steps to ensure a smooth and memorable experience:</div>
//                         </div>
//                         <div className="plan-steps-block text-center pb-50 pt-50 d-pt-50 d-pb-100">
//                             <h3 className="main-heading-font uppercase pb-10">1. PICK A VENUE</h3>
//                             <div className="text">Decide whether you want to stay in the Highlands, near Edinburgh, on the coast, or by a loch. Each offers a different vibe—remote wilderness, historical cities, or scenic seclusion. <Link>Get our expert help selecting a region and it’s private stay options.</Link></div>
//                         </div>
//                         <div className="grid-row d-grid">
//                             <div className="grid-item grid-small position-relative">
//                                 <img width="" height="" src={config.BASE_URL + event?.venueTabLeftImage} alt="" />
//                                 <div className="text text-right position-absolute">
//                                     <h3 className="cursive-title-block text-no-wrap">{event?.venueTabTitle}</h3>
//                                 </div>
//                             </div>
//                             <div className="grid-item grid-large">
//                                 <img width="" height="" src={config.BASE_URL + event?.venueTabRightImage} alt="" />
//                             </div>
//                         </div>
//                         <div className="plan-steps-block text-center pb-50 pt-50 d-pt-100 d-pb-80">
//                             <h3 className="main-heading-font uppercase pb-10">2. WORK WITH LOCAL VENDORS</h3>
//                             <div className="text">Look for castles that match your group size and style—some are rustic and traditional, while others are fully modernized. Many listings are on platforms like Airbnb Luxe, Oliver’s Travels, and private estate websites.</div>
//                         </div>
//                         <div className="large-image-block">
//                             <img className="cover" src={eventLargeImage} />
//                         </div>
//                         <div className="plan-steps-block text-center pb-50 pt-50 d-pt-100 d-pb-100">
//                             <h3 className="main-heading-font uppercase pb-10">3. CREATE AN ITINERARY FOR GUESTS</h3>
//                             <div className="text">Determine what's included—some castles come with staff, meals, and activities, while others are self-catering.</div>
//                         </div>
//                         <div className="grid-row d-grid">
//                             <div className="grid-item grid-small position-relative">
//                                 <img width="" height="" src={config.BASE_URL + event?.venueTabLeftImage} alt="" />
//                                 <div className="text text-right position-absolute">
//                                     <h3 className="cursive-title-block text-no-wrap">{event?.venueTabTitle}</h3>
//                                 </div>
//                             </div>
//                             <div className="grid-item grid-large">
//                                 <img width="" height="" src={config.BASE_URL + event?.venueTabRightImage} alt="" />
//                             </div>
//                         </div>
//                         <div className="plan-steps-block text-center pb-50 pt-50 d-pt-100 d-pb-100">
//                             <h3 className="main-heading-font uppercase pb-10">4. WORK WITH TOP CREATIVES</h3>
//                             <div className="text">Look for castles that match your group size and style—some are rustic and traditional, while others are fully modernized. Many listings are on platforms like Airbnb Luxe, Oliver’s Travels, and private estate websites.</div>
//                         </div>
//                         <div className="large-image-block">
//                             <img className="cover" src={eventLargeImage} />
//                         </div>
//                     </div>
//                 </div>

//                 {/* <div className="richtext color-light center bg-black pb-100">
//                     <div className="container">
//                         <div className="richtext-block m-auto">
//                             <p>{event?.venueTabDesc}</p>
//                         </div>
//                     </div>
//                 </div> */}

//                 <div className="additional-section center pt-60 d-pt-100 pb-60 d-pb-80" ref={itineraryRef}>

//                     <div className="title-with-line start">
//                         <div className="container">
//                             <div className="title-with-line-wrapper">
//                                 <h3 className="cursive-title-block">additional</h3>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="container pt-30 d-pt-50">
//                         <div className="summary-block start">
//                             <div className="text">We can provide and arrange additional details and arrangements that can make your stay extra special.</div>
//                         </div>
//                     </div>
//                     <div className="container m-px-0 pt-40 d-pt-50">
//                         <div className="grid-row">
//                             <Swiper
//                                 spaceBetween={25}
//                                 loop={true}
//                                 centeredSlides={true}
//                                 initialSlide={2}
//                                 slidesPerView={1.4}
//                                 breakpoints={{
//                                     1024: {
//                                         loop: false,
//                                         centeredSlides: false,
//                                         slidesPerView: 3,
//                                         spaceBetween: 30,

//                                     },
//                                 }}
//                             >
//                                 {(event?.itineraryContent && event?.itineraryContent.length > 0) && event?.itineraryContent.map((item, key) => (
//                                     <SwiperSlide>
//                                         <div className="grid-item">
//                                             <div className="image-block">
//                                                 <img width="" height="" src={config.BASE_URL + item?.itineraryImage} alt="" />
//                                             </div>
//                                             <div className="title-block">
//                                                 <h5>{item?.title}</h5>
//                                             </div>
//                                         </div>
//                                     </SwiperSlide>
//                                 ))}
//                             </Swiper>
//                         </div>
//                     </div>
//                 </div>

//                 {/* {event && (
//                     <div className="hero-section d-flex justify-content-center align-items-center position-relative">
//                         <div className="hero-banner">
//                             <picture>
//                                 <source media="(max-width:768px)" srcSet={event?.venueBannerImage2 && config.BASE_URL + event?.venueBannerImage2} />
//                                 <img width="" height="" src={event?.venueBannerImage2 && config.BASE_URL + event?.venueBannerImage2} alt="" />
//                             </picture>
//                         </div>
//                         <div className="hero-summary color-light position-absolute m-px-20">
//                             <div className="title-block"><h2>{event?.venueBannerTitle2}</h2></div>
//                             <div className="text-block"><h3 className="cursive-title-block">{event?.venueBannerDesc2}</h3></div>
//                         </div>
//                     </div>
//                 )} */}

//                 {/* <div id="gallery" className="gallery-section color-light center m-py-50" ref={galleryRef}>
//                     <div className="grid-row equal-height pb-0">
//                         <Swiper
//                             spaceBetween={25}
//                             loop={true}
//                             centeredSlides={true}
//                             initialSlide={2}
//                             slidesPerView={1.4}
//                             breakpoints={{
//                                 1024: {
//                                     loop: false,
//                                     centeredSlides: false,
//                                     slidesPerView: 3,
//                                     spaceBetween: 0,
//                                 },
//                             }}
//                         >
//                             {event?.galleryImages?.length > 0 && event?.galleryImages.map((item, index) => (
//                                 <SwiperSlide key={index}>
//                                     <div
//                                         className="grid-item image-block"
//                                         onClick={() => handleImageClick(config.BASE_URL + item)} // Open lightbox on click
//                                         style={{ cursor: "pointer" }}
//                                     >
//                                         <img width="" height="" src={config.BASE_URL + item} alt={`Gallery image ${index + 1}`} />
//                                     </div>
//                                 </SwiperSlide>
//                             ))}
//                         </Swiper>
//                     </div>
//                 </div> */}

//                 {/* Lightbox Component */}
//                 {/* {isOpen && (
//                     <Lightbox
//                         mainSrc={currentImage}
//                         onCloseRequest={() => setIsOpen(false)} // Close the lightbox
//                     />
//                 )} */}

//                 <div id="booking" className="book-with-us hero-section d-flex justify-content-center align-items-end bottom-overlay-dark position-relative">
//                     <div className="hero-banner">
//                         <img width="" height="" src={BookingBG} alt="" />
//                     </div>
//                     <div className="hero-summary color-light position-absolute">
//                         <div className="container">
//                             <div className="grid-blocks d-flex align-items-end">
//                                 <div className="grid-block">
//                                     <div className="summary-block">
//                                         <h2>WHY BOOK WITH CALEDONIA CALLING?</h2>
//                                         <div className="text-block">Spectacular views over the Firth of Forth and is surrounded by the secluded, wooded parklands of <Link>Dalmeny Estate</Link>.</div>
//                                     </div>
//                                 </div>
//                                 <div className="grid-block">
//                                     <div className="button-block d-flex justify-content-end">
//                                         <Link className="booking-button">ENQUIRE NOW</Link>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//             </>
//         </Layout>
//     );
// };

// export default SinglePackeges;




































import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import galleryImg1 from "../assets/images/gallery-img-1.jpg";
import galleryImg2 from "../assets/images/gallery-img-2.jpg";
import galleryImg3 from "../assets/images/gallery-img-3.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from "react-router-dom";
import config from '../config';
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import eventLargeImage from "../assets/images/largeEvent.jpg"
import BookingBG from "../assets/images/bookingBackground.jpg"

import Lightbox from "react-image-lightbox"; // Import Lightbox
import "react-image-lightbox/style.css";

const SinglePackeges = () => {

    const [isOpen, setIsOpen] = useState(false); // Lightbox state
    const [currentImage, setCurrentImage] = useState(""); // Current image state
    const [event, setEvent] = useState();
    const { id: slug } = useParams();
    const eventsRef = useRef(null);
    const [activeTab, setActiveTab] = useState("venue");
    const [events, setEvents] = useState([]);
    const venueRef = useRef(null);
    const itineraryRef = useRef(null);
    const galleryRef = useRef(null);
    const [featuredEvent, setFeaturedEvent] = useState();
    const images = [galleryImg1, galleryImg2, galleryImg3]; // Array of images
    const [featuredVenue, setFeaturedVenue] = useState();
    const [venues, setVenues] = useState([]);


    const buildImg = (p) => {
        if (!p) return '';
        if (typeof p !== 'string') return '';
        if (p.startsWith('http')) return p;
        if (p.startsWith('/')) return config.BASE_URL + p;
        return config.BASE_URL + '/images/' + p;
    };

    const handleImageClick = (image) => {
        setCurrentImage(image); // Set the clicked image
        setIsOpen(true); // Open the lightbox
    };

    const fetchEvent = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/single-packege/${slug}`, { withCredentials: true });

            if (response.data) {
                setEvent(response.data);
            }

        } catch (err) {
            console.log('Failed to fetch packege');
        }
    };

    const toggleTab = (e, tabName, ref) => {
        e.preventDefault();

        setActiveTab(tabName);
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    const fetchVenues = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-venues`, { withCredentials: true });

            if (response.data) {
                let fVenue = false
                await Promise.all(response?.data?.length > 0 && response.data.map(item => {
                    if (item.isFeatured) {
                        fVenue = item;
                    }
                }));

                if (!fVenue) {
                    setFeaturedVenue(response.data[0]);
                    response.data.shift();
                    setVenues(response.data);
                } else {
                    setFeaturedVenue(fVenue);
                    setVenues(response.data);
                }

            }

        } catch (err) {
            console.log('Failed to fetch venues');
        }
    };
    useEffect(() => {
        if (slug) {
            fetchEvent();
            fetchVenues()
        }
    }, [slug]);

    if (!event) return null;

    return (
        <Layout extraClass={"single-event"}>
            <>
                <div className="single-main-banner hero-section full-screen d-flex justify-content-center align-items-end bottom-150 bottom-overlay-dark position-relative" ref={venueRef}>
                    <div className="hero-banner">
                        <img width="" height="" src={buildImg(event.featuredImage)} alt="" />
                    </div>
                    <div className="hero-summary center color-light position-absolute">
                        <div className="title-block"><h2 className="mb-0">{event?.title}</h2></div>
                    </div>
                </div>
                {/* <div className="hero-section grid-item events-section container-hero-section d-flex justify-content-center top-bottom-overlay position-relative">
                    <div className="hero-banner">
                        <img width="" height="" src={config.BASE_URL + event.featuredImage} alt="" />
                    </div>
                    <div className="hero-summary container-summary position-absolute center color-light">
                        <div className="title-block">{event?.title}</div>
                        <div className="divider position-relative">at</div>
                        <div className="summary-wrapper">
                            <div className="logo-block"><img width="" height="" src={venueIcon} alt="" /></div>
                            <div className="title-block location">{event?.venueTitle}</div>
                            <div className="cursive-title-block organizer">{event?.venueLocation}</div>
                        </div>
                    </div>
                </div> */}

                <div className="template-single image-overlap-sidetext-section py-180 m-pt-120 m-pb-120">
                    <div className="container">
                        <div className="summary-block pb-40 d-pb-70 center">
                            <p>{event.description}</p>
                        </div>
                        <div className="container-500 m-auto">
                            {/* <div className="text-block center m-auto pb-50">
                                <h5>{event?.centerContent?.topText}</h5>
                            </div> */}
                            <div className="image-block position-relative">
                                <img width="" height="" src={buildImg(event?.centerContentImage)} alt="" />
                                <div className="text text-left cursive-title-block position-absolute">{event?.centerContent?.leftText}</div>
                                <div className="text text-right cursive-title-block position-absolute">{event?.centerContent?.rightText}</div>
                            </div>
                            <div className="bottom-text center d-flex justify-content-center m-auto w-100 pt-60">
                                <div className="text-item">
                                    <div className="title-block">Best For</div>


                                    < div className="text-block">
                                        {/* {event?.attributeBestFor && event?.attributeBestFor.length > 0 && (
                                        event?.attributeBestFor.map((attr, index) => (
                                            <span key={index} >
                                                {attr}
                                            </span>
                                        ))
                                    )} */}

                                        {event?.attributeBestFor && event?.attributeBestFor.length > 0 && (
                                            <span>{event.attributeBestFor.join(", ")}</span>
                                        )}

                                    </div>
                                </div>
                                <div className="text-item">
                                    <div className="title-block">Best Season</div>
                                    <div className="text-block">
                                        {event?.attributeBestSeason && event?.attributeBestSeason.length > 0 && (
                                            <span>{event.attributeBestSeason.join(", ")}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                <div className="title-with-line">
                    <div className="container">
                        <div className="title-with-line-wrapper"><h3 className="cursive-title-block">details</h3></div>
                    </div>
                </div>

                <div className="tab-section-scroll">
                    <ul className="list-style-none d-flex justify-content-center align-items-end">
                        <li><a href="#event-spaces" onClick={(e) => toggleTab(e, "venue", venueRef)} className={`${activeTab === "venue" ? 'active' : ''}`}>TOP VENUES</a></li>
                        <li><a href="#accomodation" onClick={(e) => toggleTab(e, "itinerary", itineraryRef)} className={`${activeTab === "itinerary" ? 'active' : ''}`}>HOW TO PLAN</a></li>
                        <li><a href="#near-by" onClick={(e) => toggleTab(e, "gallery", galleryRef)} className={`${activeTab === "gallery" ? 'active' : ''}`}>BOOK WITH US</a></li>
                    </ul>
                </div>

                {featuredVenue && (
                    <div id="venue" className="venue-banner hero-section full-screen d-flex justify-content-center align-items-end bottom-150 bottom-overlay-dark position-relative" ref={venueRef}>
                        <div className="hero-banner">
                            <img width="" height="" src={buildImg(featuredVenue?.featuredImage)} alt="" />
                        </div>
                        <div className="hero-summary center color-light position-absolute">
                            <div className="title-block"><h2 className="mb-0">{featuredVenue?.title}</h2></div>
                            <div className="text-block">{featuredVenue?.description}</div>
                        </div>
                    </div>
                )}
                <div className="top-venue-section">
                    <div className="container m-px-0" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
                        <div className="event-items py-100">
                            <div className="grid-row">
                                <Swiper
                                    spaceBetween={20}
                                    loop={true}
                                    centeredSlides={true}
                                    slidesPerView={1.4}
                                    initialSlide={2}
                                    breakpoints={{
                                        993: {
                                            loop: false,
                                            centeredSlides: false,
                                            slidesPerView: 3,
                                            spaceBetween: 30,
                                        },
                                    }}
                                >
                                    {/* <SwiperSlide>
                                        <div className="grid-item">
                                            <Link to=''>
                                                <div className="image-block"><img className="w-100" width="" height="" src={galleryImg1} alt="" /></div>
                                                <div className="title-block">Dundas Castle</div>
                                                <div className="cursive-title-block location ">west lothia</div>
                                                <div className="title-block organizer">Dalmeny</div>

                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="grid-item">
                                            <Link to=''>
                                                <div className="image-block"><img className="w-100" width="" height="" src={galleryImg1} alt="" /></div>
                                                <div className="title-block">Dundas Castle</div>
                                                <div className="cursive-title-block location ">west lothia</div>
                                                <div className="title-block organizer">Dalmeny</div>

                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="grid-item">
                                            <Link to=''>
                                                <div className="image-block"><img className="w-100" width="" height="" src={galleryImg1} alt="" /></div>
                                                <div className="title-block">Dundas Castle</div>
                                                <div className="cursive-title-block location ">west lothia</div>
                                                <div className="title-block organizer">Dalmeny</div>

                                            </Link>
                                        </div>
                                    </SwiperSlide> */}


                                    {(venues && venues.length) > 0 && venues.map((item, idx) => (
                                        <SwiperSlide key={idx}>
                                            <div className="grid-item">
                                                <Link to={`/single-venue/${item?.slug}`}>
                                                    <div className="image-block">
                                                        <img className="w-100" src={buildImg(item?.featuredImage)} alt={item.title} />
                                                    </div>
                                                    <div className="title-block">{item.title}</div>
                                                    <div className="cursive-title-block location">{item?.city}</div>
                                                    <div className="title-block organizer">{item?.state}</div>

                                                </Link>
                                            </div>
                                        </SwiperSlide>
                                    ))}

                                </Swiper>
                            </div>
                            <div className="view-all-button view-all-button d-flex d-pt-60">
                                <Link to="">VIEW ALL VENUES</Link>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="image-column-section bg-black color-light center py-100">
                    <div className="container m-px-0">
                        <div className="section-intro text-center pb-30 d-pb-100">
                            <h2>HOW TO PLAN</h2>
                            <div className="text-block">Planning a private castle stay in Scotland involves a few key steps to ensure a smooth and memorable experience:</div>
                        </div>

                        {/* <div className="plan-steps-block text-center pb-50 pt-50 d-pt-50 d-pb-100">
                            <h3 className="main-heading-font uppercase pb-10">1. PICK A VENUE</h3>
                            <div className="text">Decide whether you want to stay in the Highlands, near Edinburgh, on the coast, or by a loch. Each offers a different vibe—remote wilderness, historical cities, or scenic seclusion. <Link>Get our expert help selecting a region and it’s private stay options.</Link></div>
                        </div>
                        <div className="grid-row d-grid">
                            <div className="grid-item grid-small position-relative">
                                <img width="" height="" src={config.BASE_URL + event?.venueTabLeftImage} alt="" />
                                <div className="text text-right position-absolute">
                                    <h3 className="cursive-title-block text-no-wrap">{event?.venueTabTitle}</h3>
                                </div>
                            </div>
                            <div className="grid-item grid-large">
                                <img width="" height="" src={config.BASE_URL + event?.venueTabRightImage} alt="" />
                            </div>
                        </div>
                        <div className="plan-steps-block text-center pb-50 pt-50 d-pt-100 d-pb-80">
                            <h3 className="main-heading-font uppercase pb-10">2. WORK WITH LOCAL VENDORS</h3>
                            <div className="text">Look for castles that match your group size and style—some are rustic and traditional, while others are fully modernized. Many listings are on platforms like Airbnb Luxe, Oliver’s Travels, and private estate websites.</div>
                        </div>
                        <div className="large-image-block">
                            <img className="cover" src={eventLargeImage} />
                        </div>
                        <div className="plan-steps-block text-center pb-50 pt-50 d-pt-100 d-pb-100">
                            <h3 className="main-heading-font uppercase pb-10">3. CREATE AN ITINERARY FOR GUESTS</h3>
                            <div className="text">Determine what's included—some castles come with staff, meals, and activities, while others are self-catering.</div>
                        </div>
                        <div className="grid-row d-grid">
                            <div className="grid-item grid-small position-relative">
                                <img width="" height="" src={config.BASE_URL + event?.venueTabLeftImage} alt="" />
                                <div className="text text-right position-absolute">
                                    <h3 className="cursive-title-block text-no-wrap">{event?.venueTabTitle}</h3>
                                </div>
                            </div>
                            <div className="grid-item grid-large">
                                <img width="" height="" src={config.BASE_URL + event?.venueTabRightImage} alt="" />
                            </div>
                        </div>
                        <div className="plan-steps-block text-center pb-50 pt-50 d-pt-100 d-pb-100">
                            <h3 className="main-heading-font uppercase pb-10">4. WORK WITH TOP CREATIVES</h3>
                            <div className="text">Look for castles that match your group size and style—some are rustic and traditional, while others are fully modernized. Many listings are on platforms like Airbnb Luxe, Oliver’s Travels, and private estate websites.</div>
                        </div>
                        <div className="large-image-block">
                            <img className="cover" src={eventLargeImage} />
                        </div> */}


                        {/* <div className="richtext color-light center bg-black pb-100">
                    <div className="container">
                        <div className="richtext-block m-auto">
                            <p>{event?.venueTabDesc}</p>
                        </div>
                    </div>
                </div> */}
                        {event?.plans?.map((step, key) => (
                            // <div key={key + 1}>
                            <>
                                {/* Heading & description block */}
                                <div className={`plan-steps-block text-center pb-50 pt-50`}>
                                    <h3 className="main-heading-font uppercase pb-10">{`${key + 1}. ${step.title}`}</h3>
                                    <div className="text">
                                        {step?.description}{" "}
                                        {step?.linkText && step?.linkUrl && (
                                            <Link to={step?.linkUrl}>Link{step?.linkText}</Link>
                                        )}
                                    </div>
                                </div>

                                {/* Conditional image rendering */}
                                {Array.isArray(step?.others) && step.others.length === 2 && (
                                    <div className="grid-row d-grid">
                                        <div className="grid-item grid-small position-relative">
                                            <div className="image-block">
                                                <img className="w-100" src={buildImg(step.others[0]?.image)} alt="" />
                                            </div>
                                            {step.others[0]?.text && (
                                                <div className="text text-right position-absolute">
                                                    <h3 className="cursive-title-block text-no-wrap">{step.others[0].text}</h3>
                                                </div>
                                            )}
                                        </div>
                                        <div className="grid-item grid-large position-relative">
                                            <div className="image-block">
                                                <img className="w-100" src={buildImg(step.others[1]?.image)} alt="" />
                                            </div>
                                            {/* first modify */}
                                            {step.others[1]?.text && (
                                             <div className="position-absolute bottom-0 start-0 px-30 d-px-70 pb-20 z-1">
                                                <h5 className="">{step.others[1].text}</h5>
                                             </div>   
                                            )}
                                        </div>
                                    </div>
                                )}

                                {Array.isArray(step?.others) && step.others.length === 1 && (
                                    <div className="large-image-block">
                                        <img className="cover" src={buildImg(step?.others[0]?.image)} alt="" />
                                    </div>
                                )}

                                {Array.isArray(step?.others) && step.others.length > 2 && (
                                    <div className="detail_item_inner" style={{ display: 'flex', gap: 20, flexWrap: 'wrap', justifyContent: 'center' }}>
                                        {step.others.map((det, idx) => (
                                            <div key={idx} className="image-block" style={{ width: 260 }}>
                                                {det?.image && <img className="w-100" src={buildImg(det.image)} alt="" />}
                                                {det?.text && (
                                                    <div className="title-block" style={{ marginTop: 8 }}>{det.text}</div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                            // </div>
                        ))}
                    </div>
                </div>
                <div className="additional-section center pt-60 d-pt-100 pb-60 d-pb-80" ref={itineraryRef}>

                    <div className="title-with-line start">
                        <div className="container">
                            <div className="title-with-line-wrapper">
                                <h3 className="cursive-title-block">additional</h3>
                            </div>
                        </div>
                    </div>
                    <div className=" pt-30 d-pt-50 pb-30 d-pb-50">
                        <div className="container">
                            <div className="summary-block start">
                                <div className="text">
                                    {event?.additionalDetails[0]?.text}</div>
                            </div>
                        </div>
                    </div>
                    <div className="container m-px-0">
                        <div className="grid-row">
                            <Swiper
                                spaceBetween={25}
                                loop={true}
                                centeredSlides={true}
                                initialSlide={2}
                                slidesPerView={1.4}
                                breakpoints={{
                                    1024: {
                                        loop: false,
                                        centeredSlides: false,
                                        slidesPerView: 3,
                                        spaceBetween: 30,

                                    },
                                }}
                            >
                                {(event?.additionalDetails && event?.additionalDetails[0]?.details.map((item, key) => (
                                    <SwiperSlide key={key}>
                                        <div className="grid-item">
                                            <div className="image-block">
                                                <img width="" height="" src={buildImg(item?.image)} alt="" />
                                            </div>
                                            <div className="title-block">
                                                <h5>{item?.description}</h5>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )))}
                            </Swiper>
                        </div>
                    </div>
                </div>

                {/* {event && (
                    <div className="hero-section d-flex justify-content-center align-items-center position-relative">
                        <div className="hero-banner">
                            <picture>
                                <source media="(max-width:768px)" srcSet={event?.venueBannerImage2 && config.BASE_URL + event?.venueBannerImage2} />
                                <img width="" height="" src={event?.venueBannerImage2 && config.BASE_URL + event?.venueBannerImage2} alt="" />
                            </picture>
                        </div>
                        <div className="hero-summary color-light position-absolute m-px-20">
                            <div className="title-block"><h2>{event?.venueBannerTitle2}</h2></div>
                            <div className="text-block"><h3 className="cursive-title-block">{event?.venueBannerDesc2}</h3></div>
                        </div>
                    </div>
                )} */}

                {/* <div id="gallery" className="gallery-section color-light center m-py-50" ref={galleryRef}>
                    <div className="grid-row equal-height pb-0">
                        <Swiper
                            spaceBetween={25}
                            loop={true}
                            centeredSlides={true}
                            initialSlide={2}
                            slidesPerView={1.4}
                            breakpoints={{
                                1024: {
                                    loop: false,
                                    centeredSlides: false,
                                    slidesPerView: 3,
                                    spaceBetween: 0,
                                },
                            }}
                        >
                            {event?.galleryImages?.length > 0 && event?.galleryImages.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div
                                        className="grid-item image-block"
                                        onClick={() => handleImageClick(config.BASE_URL + item)} // Open lightbox on click
                                        style={{ cursor: "pointer" }}
                                    >
                                        <img width="" height="" src={config.BASE_URL + item} alt={`Gallery image ${index + 1}`} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div> */}

                {/* Lightbox Component */}
                {/* {isOpen && (
                    <Lightbox
                        mainSrc={currentImage}
                        onCloseRequest={() => setIsOpen(false)} // Close the lightbox
                    />
                )} */}

                <div id="booking" className="book-with-us hero-section d-flex justify-content-center align-items-end bottom-overlay-dark position-relative">
                    <div className="hero-banner">
                        <img width="" height="" src={buildImg(event?.bookingInfo?.image)} alt="" />
                    </div>
                    <div className="hero-summary color-light position-absolute">
                        <div className="container">
                            <div className="grid-blocks d-flex align-items-end">
                                <div className="grid-block">
                                    <div className="summary-block">
                                        <h2>WHY BOOK WITH CALEDONIA CALLING?</h2>
                                        <div className="text-block">{event?.bookingInfo?.description} <Link>{event?.bookingInfo?.link}</Link>.</div>
                                    </div>
                                </div>
                                <div className="grid-block">
                                    <div className="button-block d-flex d-justify-content-end">
                                        <Link className="booking-button">ENQUIRE NOW</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        </Layout >
    );
};

export default SinglePackeges;